
import './App.css';
import AllRoutes from './components/AllRoutes';

function App() {
  return (
    <div className="">
      <AllRoutes/>
    </div>
  );
}

export default App;
